<template>
  <div class="s-financialApplyFor-container container financialApplyFor">
    <topNav></topNav>
    <div class="topBg">
        <div class="banner w1300 marginAuto"></div>
      </div>
    <div class="section w1300 marginAuto">
      <div class="crumbs">
        <img src="../assets/image/index/home.png" class="img" alt />
        <!-- <span v-if="showCrumbs == 'index'" @click="goRoute('index')" class="go">首页&gt;</span> -->
        <span @click="goRoute('resourceLibrary')" class="go">病虫害资源库&gt;</span>
        <span>病虫害资源库详情</span>
      </div>
      <!-- <div class="top-part">

      </div> -->
      <div class="show_content_box">

        <!-- 详情部分 -->
        <div class="detail_contetn">
          <div class="top_msg">
            <span class="title"> {{ detialData.title }}</span>
            <span class="title_detail" >发病详情</span>
            <span style="font-weight: normal;">上传时间： {{ detialData.createDate }}</span>
          </div>
          <div class="show_content">
            <div class="d_left">
              <div class="top_img">
                <img v-show="activeHover == index" v-for="(item,index) in imgList" :key="index" :src="diseasesInsectPestsImgURL + item" alt="">
              </div>
              <div class="hover_img">
                <div class="hover_item" @mouseleave="leaveImg" @mouseenter="enterImg(index)" :class="activeHover == index ? 'activeHover':''" v-for="(item,index)  in imgList" :key="index">
                  <img :src="diseasesInsectPestsImgURL + item" alt="">
                </div>

              </div>
            </div>
            <div class="d_right">
              <!-- <div class="title">
              {{ detialData.title }}
              <span style="font-weight: normal;">上传时间： {{ detialData.createDate }}</span>
              <span></span>
            </div> -->
              <!-- <p>发病详情</p> -->
              <div class="fabingdetail" v-html="detialData.diseaseDescribe">
              </div>
              <p style="margin-bottom: 6px;">防治方法</p>
              <div class="prevent_methods" v-html="detialData.preventionPlan">

              </div>

            </div>
          </div>

        </div>

        <!-- 相似病例 -->
        <div class="similarity">
          <div class="word"><img src="../assets/image/financialInsurance/step2.png" alt="">相似病例</div>
          <div v-if="xsImglist.length != 0" class="carousel">
            <el-carousel :arrow="isArrow" height="380px" :autoplay="false" indicator-position="none">
              <el-carousel-item v-for="(item,index) in xsImglist" :key="index">
                <!-- <h3>{{ item }}</h3> -->
                <div class="img_box">
                  <div class="img_item" @click="handleDetail(ele)" v-for="(ele,ind) in item" :key="ind">
                    <div class="item_top_img">
                      <img :src="diseasesInsectPestsImgURL + ele.pathogenUrl" alt="">
                    </div>
                    <div class="item_bottom_msg">{{ ele.diseaseName }}</div>

                  </div>
                </div>

              </el-carousel-item>
            </el-carousel>
          </div>
          <div v-else>
            <el-empty description="暂无数据！" :image="noDataImg" :image-size="400"></el-empty>
          </div>
        </div>
      </div>
    </div>
    <footerNav></footerNav>

  </div>
</template>

  <script>
import topNav from "../components/topNav.vue";
import footerNav from "../components/footerNav.vue";
import { details, pageList } from "../utils/api/diseasesInsectPests";
export default {
  name: "financialApplyFor",
  components: { topNav, footerNav },
  data() {
    return {
      activeHover: 0,
      detialData: {},
      imgList: [],
      xsImglist: [],
      isArrow: "always",
      dataId: "",
      noDataImg:require('../assets/image/pest/no-data.jpg')
    };
  },
  computed: {
    // dataId() {
    //   return this.$route.query.id;
    // },
    dataType() {
      return this.$route.query.type;
    },
    positionType() {
      return this.$route.query.positionType;
    },
  },
  mounted() {
    this.dataId = this.$route.query.id;
    this.getDetail();
    this.pageList();
  },
  methods: {
    async getDetail() {
      let res = await details({ id: this.dataId, type: this.dataType });
      //  this.diseasesInsectPestsImgURL
      if (res.data.code === 0) {
        var that = this;
        if (this.dataType == 0) {
          this.detialData = {
            title: res.data.data.diseaseName,
            diseaseDescribe: res.data.data.diseaseDescribe,
            preventionPlan: res.data.data.preventionPlan,
            img: `${this.diseasesInsectPestsImgURL}${
              res.data.data.diseaseImg.split(";")[0]
            }`,
            // img: `http://39.105.176.120:28081${res.data.data.diseaseImg.split(";")}`,
            createDate: res.data.data.createDate,
          };
          this.imgList = res.data.data?.diseaseImg?.split(";") ?? [];
          //   this.imgList.forEach((item) => {
          //     item = `${that.diseasesInsectPestsImgURL}${item}`;
          //   });
          //   console.log("res.data.data?.diseaseImg", res.data.data?.diseaseImg);
        } else {
          this.detialData = {
            title: res.data.data.pestName,
            diseaseDescribe: res.data.data.pestDescribe,
            preventionPlan: res.data.data.preventionPlan,
            img: `${this.diseasesInsectPestsImgURL}${
              res.data.data.pestUrl.split(";")[0]
            }`,
            // img:`http://39.105.176.120:28081${ res.data.data.pestUrl.split(";")}`,
            createDate: res.data.data.createDate,
          };
          this.imgList = res.data.data?.pestUrl?.split(";") || [];

          //   console.log("this.imgList", this.imgList);

          //   this.imgList.forEach((item) => {
          //     debugger;
          //     item = `${that.diseasesInsectPestsImgURL}${item}`;
          //   });
          //   //   console.log(" res.data.data?.pestUrl", res.data.data?.pestUrl);
          //   console.log("this.imgList2", this.imgList);
        }
      }
    },
    // 相似病例
    async pageList() {
      var params = {
        currentPage: 1,
        pageSize: 50,
        positionType: this.positionType,
        type: this.dataType,
        title: "",
      };
      let res = await pageList(params);
      if ([0, 200].includes(res.data.code)) {
        var arr = res.data.data.records.map((item) => {
          return {
            pathogenUrl: item.pestUrl,
            diseaseName: item.pestName,
            id: item.id,
          };
        });
        this.xsImglist = this._.chunk(arr, 4);
        if (this.xsImglist.length <= 1) {
          this.isArrow = "never";
        } else {
          this.isArrow = "always";
        }
        console.log("this.xsImglist", this.xsImglist, arr);
      }
    },
    handleDetail(item) {
      this.dataId = item.id;
      this.getDetail();
      this.pageList();
    },
    // ------------------------------------------------
    goRoute(url) {
      this.$router.push({ path: url });
    },
    enterImg(val) {
      this.activeHover = val;
    },
    leaveImg() {},
  },
};
</script>

<style lang="scss">
@import "../utils/css/common.scss";
@import "../utils/css/financialInsuranceApplyFor.scss";
</style>
<style lang="scss" scoped>
p {
  font-weight: bold;
  font-size: 20px;
}
.show_content_box {
  user-select: none;
  min-height: 800px;
  //   border: 1px solid #ccc;
  margin-bottom: 10px;
  .detail_contetn {
    width: 100%;
    box-sizing: border-box;
    height: auto;

    // position: relative;
    .top_msg {
      width: 100%;
      position: relative;
      display: flex;
      justify-content: space-between;
      height: 36px;
      line-height: 36px;
      .title_detail,
      .title {
        font-size: 20px;
        font-weight: bold;
        height: 36px;
        line-height: 36px;
        display: flex;
        justify-content: space-between;
      }
      .title_detail {
        position: absolute;
        left: 41%;
        // top: 4px;
      }
    }
    .show_content {
      display: flex;
      justify-content: space-between;
      margin-bottom: 60px;

      .d_left {
        width: 40%;
        height: 500px;
        .top_img {
          height: 400px;
          width: 100%;
          box-sizing: border-box;
          margin-bottom: 10px;
          border: 1px solid rgba($color: #000000, $alpha: 0.1);
          img {
            height: 100%;
            width: 100%;
          }
        }
        .hover_img {
          // display: flex;
          height: 90px;
          // justify-content: space-between;
          .hover_item {
            height: 100%;
            width: 24%;
            box-sizing: border-box;
            float: left;
            margin-right: 1.333%;
            img {
              height: 100%;
              width: 100%;
            }
            cursor: pointer;
            &:nth-of-type(4) {
              margin-right: 0;
            }
          }
          .activeHover {
            border-radius: 4px;
            border: 1px solid #32bb6e;
            box-sizing: border-box;
            padding: 2px;
          }
        }
      }
      .d_right {
        width: 59%;
        .title {
          font-size: 20px;
          font-weight: bold;
          height: 36px;
          line-height: 36px;
          display: flex;
          justify-content: space-between;
        }
        .prevent_methods,
        .fabingdetail {
          text-indent: 2em;
          // margin-top: 10px;
          // min-height: 192px;
          // max-height: 260px;
          height: 192px;
          overflow-y: auto;
          background-color: #f8f8f8;
          margin-bottom: 10px;
          border-radius: 6px;
          font-size: 14px;
          font-family: PingFangSC;
          font-weight: 400;
          color: #333333;
          padding: 10px 15px;
          box-sizing: border-box;
          line-height: 22px;
        }
        .prevent_methods {

          height: 280px;
          overflow-y: auto;
        }
      }
    }
  }
  .similarity {
    // height: 380px;
    padding-top: 16px;
    position: relative;
    border-top: 1px solid #d3d3d3;
    .word {
      position: absolute;
      left: 0;
      font-size: 20px;
      top: -33px;

      height: 30px;
      line-height: 30px;
      font-weight: bold;
      border-bottom: 3px solid #32bb6e;
      img {
        height: 26px;
        width: 26px;
        box-sizing: border-box;
        vertical-align: middle;
        margin-right: 6px;
      }
    }
  }
}
</style>
<style lang="scss" >
.carousel {
  //   padding-top: 20px;
  height: 100%;
  //   padding: 0 60px;
  //   border: 1px solid #ccc;
  .el-carousel__item {
    text-align: center;
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;

    .img_box {
      height: 100%;
      display: flex;
      //   border: 1px solid #ccc;
      //   width: 90%;
      width: 100%;
      margin: 0 auto;
      box-sizing: border-box;
      .img_item {
        width: 24%;
        height: 100%;
        // background-color: khaki;
        margin-right: 1.3333%;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-sizing: border-box;
        cursor: pointer;

        &:nth-of-type(4) {
          margin-right: 0;
        }
        .item_top_img {
          height: 340px;
          img {
            height: 100%;
            width: 100%;
          }
        }
        .item_bottom_msg {
          padding: 0 4px;
          box-sizing: border-box;
          height: 40px;
          line-height: 30px;
          font-weight: bold;
          font-size: 20px;
          //   text-align: left;
        }
      }
    }
  }

  //   .el-carousel__item:nth-child(2n) {
  //     // background-color: #99a9bf;
  //   }

  //   .el-carousel__item:nth-child(2n + 1) {
  //     // background-color: #d3dce6;
  //   }
}
.no_data {
  height: 380px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 22px;
  border: 1px solid rgba($color: #000000, $alpha: 0.1);
  border-radius: 4px;
}
</style>
